import { graphql } from '@eluve/graphql.tada';

export const getPatientVisitDatesQuery = graphql(`
  query getPatientVisitDates(
    $tenantId: uuid!
    $patientId: uuid!
    $now: timestamptz!
  ) {
    lastVisit: appointmentsAggregate(
      where: {
        tenantId: { _eq: $tenantId }
        patientId: { _eq: $patientId }
        status: { _eq: COMPLETED }
      }
    ) {
      aggregate {
        max {
          startDate
        }
      }
    }
    nextVisit: appointmentsAggregate(
      where: {
        tenantId: { _eq: $tenantId }
        patientId: { _eq: $patientId }
        status: { _neq: CANCELLED }
        startDate: { _gt: $now }
      }
    ) {
      aggregate {
        min {
          startDate
        }
      }
    }
  }
`);
